__turbopack_context__.v({
  "root": "AccordionGroupItemBlok-module__CcBhKa__root",
});
